import React from "react";
import { Button } from "reactstrap";
import "./SimpleButton.scss";
import cn from "classname";
import { isB2B } from "../../libs/env";
import { useCustomOrigin } from "../custom_origin/CustomOriginContext";

const B2CSubmitButton = ({ isSubmitting, IsonRecorder, btnContent = "Submit", ...props }) => {
  let btn_color="btn-purple";
  let customOrigin = useCustomOrigin();
  if (isB2B.some(domain => customOrigin.includes(domain))) {
    btn_color = "btn-warning";
  }
  return (
    <Button
      className={
        isSubmitting 
        ? cn(`btn disabled py-2 rounded-5 d-flex align-items-center justify-content-center ${btn_color} btn-lg`)
        : IsonRecorder
        ? cn(`btn py-2 rounded-5 disabled d-flex  align-items-center justify-content-center ${btn_color} btn-lg`)
        : cn(`btn py-2 rounded-5 d-flex ${btn_color} btn-lg`)
        }
      data-tc="submit-task"
      {...props}
    >
      {isSubmitting ? (
        <>
          <span className="spinner-border spinner-border-sm me-2 d-flex align-items-center justify-content-center">
          </span> 
          <span className="fw-600">{btnContent}</span>
        </>
      ):
      (
        <>
          <span className="fw-600">{btnContent}</span>
        </>
      )}
    </Button>
  );
};

export default B2CSubmitButton;
